import { UserExerciseSession } from '../../entities';
import { BandWeightAdjustment } from './BandWeightAdjustment';
import {
  EquipmentWeightForExerciseInZone,
  IEquipmentWeightForExerciseInZone,
  IWeightAdjustmentStrategy,
} from './EquipmentWeightCalculator';

export class NonQuadFormatWeightAdjustment
  extends BandWeightAdjustment
  implements IWeightAdjustmentStrategy {
  public adjustExerciseWeights(
    exerciseSession: UserExerciseSession,
    equipmentMap: EquipmentWeightForExerciseInZone,
  ) {
    for (const key of Object.keys(equipmentMap)) {
      const equipmentWeightList: IEquipmentWeightForExerciseInZone[] =
        equipmentMap[key];
      if (!this.equipmentWeightsNeedAjusting(equipmentWeightList)) {
        return;
      }
      const lightestEquipmentWeightInfo =
        this.getLightestWeight(equipmentWeightList).equipmentWeightInfo;
      this.setEquipmentWeightInfoForExercisesInZone(
        exerciseSession,
        equipmentWeightList,
        lightestEquipmentWeightInfo,
      );
    }
  }
}
